import React, { Component } from 'react';
import './Header.css';
import MenuIcon from '../MenuIcon';

class Header extends Component {
  render() {
    let { mobile, full, staticOpen, onToggle } = this.props;
    return (
      <div className={"Header" + (mobile ? " Header--mobile": "") + (staticOpen ? " Header--static" : "") + (full ? " Header--full": "")}>
        <div className="Wrapper Header__wrapper">
          <div className="Header__logo">
            amagroup
          </div>
          { !mobile ?
          <button className={"Header__menu" + (staticOpen ? " Header__menu--open" : "")} onClick={onToggle}>
            <MenuIcon open={staticOpen} />
          </button>
          : null}
        </div>
      </div>
    );
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/index.js
 **/